import React from "react";
import {
  Container,
  Typography,
  Paper,
  List,
  ListItem,
  ListItemText,
  Box,
} from "@mui/material";
// cancellationData.js
const cancellationData = {
  title: "Order Cancellation Policy – Yubai",
  description: "No order cancellations are accepted once an order has been placed.",
  points: [
    "After you confirm your purchase on Yubai, the order is immediately processed with our suppliers, warehouses, and logistics partners.",
    "Because we operate in cross-border e-commerce (UAE → Lebanon/Iraq and other markets), shipments are consolidated and exported within hours. This makes cancellation impossible once submitted.",
    "Customers may still use the Return & Refund Policy after delivery if eligible.",
  ],
  supportText: "For assistance, please contact our support team:",
  support: [
    "WhatsApp: +00961 78 777 190",
    "Email: operations@yubai.ai",
  ],
};




function CancellationPolicy() {
  return (
    <Container maxWidth="md" sx={{ mt: { xs: 2, sm: 4 }, mb: { xs: 2, sm: 6 } }}>
      <Paper
        elevation={0}
        sx={{ padding: "10px", marginTop: "20px", marginBottom: "20px" }}
      >
        {/* Title */}
        <Typography
          variant="h2"
          gutterBottom
          sx={{
            fontSize: { xs: "23px", sm: "23px", md: "24px" },
            fontFamily: "Poppins_600SemiBold",
            mb: 2,
            textAlign: "left",
            color: "text.primary",
          }} 
        >
          {cancellationData.title}
        </Typography>

 
        <Typography
          sx={{
            fontSize: { xs: "14px", sm: "14px", md: "18px" },
            lineHeight: 1.6,
            color: "#808080",
            mb: 2,
            fontFamily: "poppins",
            textAlign: "left",
          }}
        >
          {cancellationData.description}
        </Typography>

        {/* Points */}
        <List >
          {cancellationData.points.map((point, i) => (
            <ListItem key={i} sx={{ display: "list-item", pl: 0 }}>
              <ListItemText
                primary={point}
                primaryTypographyProps={{
                  sx: {
                    fontSize: { xs: "14px", sm: "16px", md: "18px" },
                    lineHeight: 1.6,
                    color: "#808080",
                    mb: 1,
                    fontFamily: "poppins",
                    textAlign: "left",
                  },
                }}
              />
            </ListItem>
          ))}
        </List>

        {/* Support Text */}
        <Typography
          variant="body1"
          sx={{
            fontSize: { xs: "14px", sm: "16px", md: "18px" },
            lineHeight: 1.6,
            color: "#808080",
            mb: 1,
            fontFamily: "poppins",
            textAlign: "left",
          }}
        >
          {cancellationData.supportText}
        </Typography>

        {/* Support List */}
        <List >
          {cancellationData.support.map((item, i) => (
            <ListItem key={i} sx={{ display: "list-item", pl: 0 }}>
              <ListItemText
                primary={item}
                primaryTypographyProps={{
                  sx: {
                    fontSize: { xs: "14px", sm: "16px", md: "18px" },
                    lineHeight: 1.5,
                    color: "#808080",
                    mb: 1,
                    fontFamily: "poppins",
                    textAlign: "left",
                  },
                }}
              />
            </ListItem>
          ))}
        </List>
      </Paper>
    </Container>
  );
}

export default CancellationPolicy;
